module.exports = __webpack_public_path__ + "img/audit-icon-active.e12555e9.svg";